// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3olNX","imageUploader":"EGiftCard_imageUploader__2biHq"};